var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tags__main--div"},[_c('a-select',{staticClass:"default__select--style",attrs:{"mode":"tags","value":_vm.selected,"placeholder":"请选择标签","size":_vm.selectSize},on:{"change":_vm.selectTags}},_vm._l((_vm.options),function(item){return _c('a-select-option',{key:item.id,attrs:{"value":item.id}},[_vm._v(_vm._s(item.name))])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }